export default function parseGUIDs(GUIDs: string[]): string[] {
	if (!GUIDs) {
		return [];
	}

	const guidRegEx = new RegExp('^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$');

	return GUIDs.map((guid) =>
		guidRegEx.test(guid.substring(guid.indexOf('_') > 0 ? guid.indexOf('_') + 1 : 0, guid.length))
			? guid.substring(guid.indexOf('_') > 0 ? guid.indexOf('_') + 1 : 0, guid.length)
			: ''
	);
}
